import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ActionsList.styled';
import ActionGroupCollapsible from '../ActionGroupCollapsible/ActionGroupCollapsible';
import ActionItem from '../ActionItem/ActionItem';

const ActionsList = (props) => {
  const allRootActionGroups = props.actionGroups.filter(
    (group) => group.parentId === null
  );

  const allNestedActionGroups = props.actionGroups.filter(
    (group) => group.parentId !== null
  );

  return (
    <Styled.ActionsListContainer>
      {allRootActionGroups.map((actionGroup, index) => (
        <ActionGroupCollapsible
          key={actionGroup.id}
          title={actionGroup.title}
          indentLevel={0}
          actionGroup={actionGroup}
          nestedActionGroups={allNestedActionGroups}
          allActions={props.actions}
        />
      ))}
      {props.actions
        .filter((action) => action.actionGroupId === null)
        .map((action) => (
          <ActionItem
            key={action.id}
            title={action.title}
            indentLevel={0}
            action={action}
          />
        ))}
    </Styled.ActionsListContainer>
  );
};

ActionsList.propTypes = {
  actions: PropTypes.array.isRequired,
};

export default ActionsList;
